import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { styled } from '@mui/material/styles';
import palette from './palette';

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})(({ theme, dayIsBetween, isFirstDay }) => ({
  ...(dayIsBetween && {
    borderRadius: 0,
    backgroundColor: palette.gt_green_1,
    color: theme.palette.common.black,
    '&:hover, &:focus': {
      backgroundColor: palette.gt_green_1,
    },
  }),
  ...(isFirstDay && {
    backgroundColor: palette.gt_green_6,
    '&:hover, &:focus': {
      backgroundColor: palette.gt_green_6,
    },
  }),
}));

export default CustomPickersDay;
